import { render } from "./NavigationFooter.vue?vue&type=template&id=c16ab598&scoped=true"
import script from "./NavigationFooter.vue?vue&type=script&lang=js"
export * from "./NavigationFooter.vue?vue&type=script&lang=js"

import "./NavigationFooter.vue?vue&type=style&index=0&id=c16ab598&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c16ab598"]])

export default __exports__